const cancel = 'Anulare'
const save = 'Salvare'

export default {

  global: {
    generalError: 'Oh nu! Cererea nu a putut fi procesată. Vă rugăm reîncărcați pagina.',
    signature: 'Toate cele bune',
  },

  component: {
    actionBar: {
      actions: 'Actions',
      hideActions: 'Hide actions',
    },

    addButton: {
      add: 'Add',
    },

    attachments: {
      add: 'Adaugă CV-ul sau alte documente',
      placeholderWithDescription: 'Adăugați accesoriile solicitate',
      remove: 'Ștergere',
      allowedFileTypes: 'Tipurile de fișiere permise',
      errors: {
        size: 'Fișierul este prea mare, dimensiunea maximă este de 5MB.',
        empty: 'Fișierul nu conține date',
        invalidType: fileType => `Ne pare rău, fișierele ${fileType} nu pot fi acceptate din motive de securitate`,
        typeNotWhitelisted: 'Ne pare rău, tipul de fișier nu este acceptat.',
      },
    },

    agreeTos: {
      privacyLinkText: 'Politica de confidențialitate',
      termsLinkText: 'Termeni și condiții',
      privacyPolicyText:
        'Prețuim confidențialitatea dumneavoastră, vă rugăm să citiți pagina noastră ',
      termsText1: 'Citiți și acceptați ',
      termsText2:
        'înainte de a ne furniza datele dumneavoastră cu caracter personal.',
      privacyLink: 'https://new.recright.com/privacy-policy',
      termsLink: 'https://new.recright.com/recright-terms-and-conditions-candidate',
      privacyInfo: mail => `Dacă nu doriți să vă procesăm datele personale, ne puteți trimite un e-mail la ${mail} în care să ne cereți să le ștergem.`,
      customSupportPrivacyInfo: link => `Dacă nu doriți să vă procesăm datele personale, puteți solicita eliminarea acestora la adresa ${link}.`,
    },

    buttons: {
      close: 'Închidere',
    },

    competencies: {
      addCompetency: 'Add a new competency',
      edit: 'Edit competencies',
      done: 'Done',
      defaultsDescription: 'If you are unsure what competencies to use, we have defined some good defaults to start with.',
      getDefaults: 'Get default competencies',
    },

    competency: {
      warning: 'Remove competency and all its ratings?',
    },

    confirmDelete: {
      delete: 'Delete',
      cancel: 'Cancel',
      confirm: 'Confirm',
    },

    confirm: {
      cancel: 'Ștergere încercare',
      confirm: 'Încearcă din nou',
    },

    confirmButton: {
      wait: count => `Așteaptă ${count}`,
      confirm: 'Confirmare',
    },

    controlStatus: {
      text: {
        empty: 'Completează',
        valid: () => 'Gata',
      },
      textarea: {
        empty: 'Completează',
        valid: (length, limit) => `${length}/${limit}`,
      },
      select: {
        empty: 'Setare',
        valid: () => 'Gata',
      },
      file: {
        empty: 'Selectare',
        valid: () => 'Schimbare',
      },
      list: {
        empty: 'Adăugare',
        valid: (length, limit) => `${length}/${limit}`,
      },
      search: {
        empty: 'Căutare',
        valid: () => 'Gata',
      },
    },

    cookieConsentModal: {
      title: 'Site-ul nostru web folosește cookie-uri',
      body: 'Acceptând toate cookie-urile, sunteți de acord cu stocarea cookie-urilor pe dispozitivul dumneavoastră pentru a îmbunătăți navigarea pe site, a analiza utilizarea site-ului și a ajuta la eforturile noastre de marketing.',
      learnMoreLinkText: 'Aflați mai multe despre cum folosim cookie-urile',
      learnMoreLink: 'https://new.recright.com/cookies/', // TODO add localized links when the page is translated
      manageCookies: 'Gestionați cookie-urile',
      acceptAll: 'Accept toate cookie-urile',
      manageTitle: 'Gestionați preferințele de consimțământ',
      necessaryCookiesTitle: 'Cookie-uri necesare',
      necessaryCookiesBody:
        'Aceste cookie-uri sunt necesare pentru ca site-ul web să funcționeze și nu pot fi dezactivate în sistemele noastre.',
      performanceCookiesTitle: 'Cookie-uri de performanță',
      performanceCookiesBody:
        'Aceste cookie-uri ne permit să numărăm vizitele și sursele de trafic, astfel încât să putem măsura și îmbunătăți performanța site-ului nostru.',
      confirmChoices: 'Confirm Alegerile Mele',
      marketingCookiesTitle: 'Cookie-uri de marketing',
      marketingCookiesBody:
        'Aceste module cookie ne permit să personalizăm reclamele și să măsurăm performanța reclamelor.',
      functionalCookiesTitle: 'Cookie-uri de funcționalitate',
      functionalCookiesBody:
        'Aceste cookie-uri sunt folosite pentru a îmbunătăți funcționalitatea site-ului. Fără aceste cookie-uri, anumite funcționalități pot deveni indisponibile. Exemple de cookie-uri de funcționalitate includ serviciile de chat web și preferințele utilizatorului.',
    },

    emailAddresses: {
      remove: 'Ștergere',
      importCsv: 'Import CSV',
      invalidEmails: 'Invalid emails found.',
      maxCsvEntryErrorNotification: amount =>
        `Max ${amount} csv entries allowed`,
      importCsvTooltip:
        'The csv rows can have email or email,phone. Each row represents a recipient. The phone numbers needs to be in international format (E.164) e.g. (<strong>+358</strong>50xxxxxxx).',
    },

    emailDeliveryStatus: {
      Undetermined: {
        Undetermined: 'Email bounced back. Make sure the recipient received your message.',
      },
      Permanent: {
        General: 'Email delivery failed. Recipients email provider rejected the message.',
        NoEmail: 'Email address does not exist.',
        Suppressed: 'Email was not delivered due to previous unsuccessful delivery attempts.',
      },
      Transient: {
        General: 'Email bounced back. Make sure the recipient received your message.',
        MailboxFull: 'Recipient inbox is full.',
        MessageTooLarge: 'The message content is too large.',
        ContentRejected: 'The message content rejected.',
        AttachmentRejected: 'The attachment rejected.',
      },
    },

    smsDeliveryStatus: {
      notDelivered: 'SMS message added to message queue, waiting for delivery.',
      failed: 'Sending SMS message failed.',
      duplicate: 'The number given is already attatched to a candidate in the interview.',
    },

    error403: {
      heading: 'Interzis',
      content: 'Serverul nostru a refuzat politicos (dar ferm) să efectueze o acțiune a browserului dumneavoastră. Rețineți că Recright trebuie folosit pe un singur dispozitiv/browser (în același timp).',
      link: 'Prima pagină',
    },

    error404: {
      heading: 'Nu e nimic aici',
      content: 'Am căutat cu atenție, dar nu există o pagină web la adresa pe care ați introdus-o. Poate ați accesat un link expirat sau ați scris din greșeală adresa greșit.',
      link: 'Prima pagină',
    },

    error410: {
      heading: 'Închis',
      content: 'Poziția nu poate fi afișată fie pentru că este închisă sau perioada de aplicare s-a sfârșit.',
      link: 'Prima pagină',
    },

    calendarError: {
      heading: 'Connecting calendar failed',
      content: 'We were unable to connect your calendar. Please try again later and if the issue continues please contact our support.',
    },

    flash: {
      starting: 'Inițializare...',
      connection_error_hint: 'Conexiunea la rețea nu a putut fi stabilită.\nÎncercați să reîncărcați pagina.',
      permission_hint: 'Trebuie să îi permiteți acestui site să folosească microfonul și camera web.',
      searching_camera_hint: 'Căutare cameră web...',
      camera_reserved_hint: 'Camera web a fost rezervată de o altă aplicație sau pagină web.\nVă rugăm închideți acea aplicație sau reîncărcați pagina.',
      camera_reserved_hint_chrome_extra: 'Dragă utilizator al Chrome, trebie să permiteți Recright să acceseze Camera web, din bara de sub cea pentru adresă.',
      no_camera_hint: 'Camera web nu a putut fi găsită.',
      no_mic_hint: 'Microfonul nu a putut fi găsit.',
      uploading_text: 'Încărcare...',
      rtmpt_in_use: 'Acest pas nu ar fi fost necesar, dacă administratorul\nrețelei dumneavoastră permitea RTMP. Întrebați-ne cum.',
      preview_text: 'Camera web este în modul de previzualizare',
      close_text: 'Închideți camera',
      remove_text: 'Ștergere încercare',
      noflash_errortext_install: link => `Se pare că nu aveți Adobe Flash Player. Aveți nevoie de un plugin flash pentru a înregistra interviuri. Descărcați-l de aici: ${link}`,
      noflash_errortext_enable: link => `Dacă ați instalat deja flash-ul, dar vedeți în continuare acest mesaj. Aruncați o privire aici: ${link}`,
      noflash_errortext_differentbrowser: 'Ca alternativă, puteți încerca cu un browser care suportă înregistrarea HTML5. Noi recomandăm Chrome sau Firefox.',
    },

    footer: {
      terms: 'Termeni',
      license: 'General Terms of Service',
      privacyPolicy: 'Politica de confidențialitate',
      customSupport: link => `Contactați ${link}`,
      accessibilityReport: 'Accessibility report',
    },

    feedbackPulse: {
      howWouldYouRateInterview: 'Cum ai evalua experiența acestui interviu?',
      howWouldYouRateJobAd: 'Cum ați evalua procesul de recrutare?',
      yourResponseIsAnonymous: 'Răspunsul tău este anonim.',
      thankYouFeedback: 'Îți mulțumim pentru feedback!',
    },

    candidateFooter: {
      termsLink: 'https://new.recright.com/recright-terms-and-conditions-candidate',
      privacyPolicyLink: 'https://new.recright.com/privacy-policy',
      accessibilityReportLink: 'https://new.recright.com/hubfs/RecRight_Accessibility_report.pdf',
    },

    formErrors: {
      typeNotWhitelisted: 'Ne pare rău, tipul de fișier nu este acceptat.',
      isRequired: 'Acest câmp este obligatoriu.',
      isEmail: value => `${value} nu este un e-mail valid.`,
      isDate: value => `${value} nu este o dată validă.`,
      invalidUrl: 'URL-ul nu este valid.',
      singleHireEndError: 'Angajarea singulară nu poate fi folosită mai mult de 60 de zile.',
      isNotTooOldForLive: 'Această dată este în trecut.',
      isNotAfterEndDate: 'The date is after the date the job ad closes.',
      isValidMobilePhone: value => `${value ? `${value} is not` : 'Not'} a valid mobile phone number.`,
      isInternationalPhoneNumber: 'Phone number must be in international format.',
      duplicateNumber: 'Phone number has already been added.',
      duplicateCompetency: 'Competency with that name already exists',
      isNotDuplicateTemplateName: 'Template with that name already exists',
    },

    jobAdApplication: {
      name: 'Numele',
      city: 'Orașul natal',
      email: 'Email',
      phone: 'Număr telefon',
      applyForPosition: 'Aplicați pentru post',
      back: 'Înapoi',
      continue: 'Continuare',
      submit: 'Trimitere',
      saveForLater: 'Continuă mai târziu',
      namePlaceholder: 'Introduceți numele dumneavoastră',
      emailPlaceholder: 'Introduceți adresa dumneavoastră de e-mail',
      phonePlaceholder: 'Introduceți numărul dumneavoastră de telefon',
      cityPlaceholder: 'Introduceți orașul actual de rezidență',
      links: 'Adăugați link-uri, cum ar fi profilul dumneavoastră de LinkedIn',
      legendBasicInfo: 'Informații de bază',
      legendLinks: 'Linkuri',
      legendAttachments: 'Documente atașate',
      legendAdditionalFields: 'Informații suplimentare',
      coverLetter: 'Scrisoare de intenție',
      attachments: 'Documente atașate',
      introduction: 'Scrieți aici o scurtă introducere ',
      thankYou: 'Mulțumim.',
      luck: 'Mult succes!',
      close: 'Închidere',
      required: 'Elementele marcate cu un * asterisc sunt obligatorii.',
    },

    jobAdContainer: {
      endTime: date => (date ? `disponibil până la ${date}` : ''),
    },

    jobAdDetails: {
      apply: 'Aplicați pentru acest post',
    },

    jobAdQuickInterview: {
      back: 'Înapoi',
      submit: 'Trimitere',
      saveForLater: 'Continuă mai târziu',
      title: 'Interviu video rapid',
      description: 'Pentru a vă cunoaște mai rapid, ne-ar plăcea să răspundeți pe scurt unui interviu rapid. Implicați-vă personalitatea și puneți suflet în cererea de aplicare.',
      requiredNote: 'Rețineți că aceasta este o parte a procesului de aplicare, iar persoana care se ocupă de recrutare va primi cererea dumneavoastră de aplicare doar după ce v-ați înregistrat răspunsul.',
      reminderNote: 'Puteți înregistra răspunsul chiar acum, sau puteți continua mai târziu, primind o notificare pe e-mail.',
    },

    jobAdRow: {
      responses: 'Aplicații',
      status: {
        open: 'Deschis',
        filled: 'Completat',
        cancelled: 'Anulat',
        done: 'Gata',
        close: 'Închidere',
        draft: 'Închis (draft)',
        hidden: 'Ascuns',
      },
    },

    interviewRow: {
      responses: 'Candidați',
    },

    linkedInProfile: {
      showLinkedInProfileModal: 'Afișează profilul Linkedin',
    },

    linkedInButton: {
      error: 'A apărut o eroare la afișarea profilului. Te rugăm încearcă din nou.',
      buttonText: 'Aplică cu LinkedIn',
    },

    linkedInContainer: {
      linkedInButtonDescription: 'Poți folosi profilul tău de Linkedin pentru a pre-completa formularul de aplicare.',
      linkedInOr: 'Sau',
      error: 'A apărut o eroare la afișarea profilului. Te rugăm încearcă din nou.',
    },

    linkListInput: {
      addField: 'Adăugare',
      removeField: 'Ștergere',
      invalidUrl: 'URL-ul nu este valid.',
    },

    liveRoom: {
      greeting: name => `Hello, ${name}.`,
      notYetStarted: startTime =>
        `The interview has not yet started. The interview starts at ${startTime}.`,
      interviewTitle: title => `Interview title: ${title}`,
      interviewStartsIn: timeLeft => `The Interview starts in: ${timeLeft}`,
      interviewHasEnded: 'The interview has ended.',
    },

    loadingButton: {
      loading: 'Procesare...',
      saving: 'Salvare...',
      sending: 'Trimitere...',
    },

    modalApplicationForm: {
      applyForPosition: 'Aplicați pentru post',
      continue: 'Continuare',
      name: 'Introduceți numele dumneavoastră',
      email: 'Introduceți adresa dumneavoastră de e-mail',
      phoneNumber: 'Introduceți numărul dumneavoastră de telefon',
      links: 'Puteți introduce linkuri',
      legendLinks: 'Linkuri',
      legendAttachments: 'Documente atașate',
      coverLetter: 'Scrisoare de intenție',
      attachments: 'Documente atașate',
      introduction: 'Scrieți aici introducerea dumneavoastră.',
      thankYou: 'Mulțumim.',
      luck: 'Mult succes!',
      close: 'Închidere',
    },

    modalConfirm: {
      cancel,
      confirm: 'OK',
    },

    modalAlert: {
      close: 'Close',
    },

    modalLinkShare: {
      title: 'Link public care poate fi partajat',
      info: 'Iată o adresă publică a unui anunț pentru o poziție, pe care o puteți partaja.\nOricine este interesat de poziție poate vedea anunțul și apoi să decidă să aplice.\nVeți primi notificările obișnuite atunci când aplicațiile încep să sosească.\n\nIată un link public pentru anunțul poziției:',
    },

    modalVideoAdd: {
      title: 'Adaugă un nou videoclip',
      chooseTitle: 'Adaugă un nou videoclip',
      titlePlaceholder: 'Introduceți aici numele videoclipului',
      cancel,
      save,
    },

    modalVideoUpload: {
      title: 'Încărcați un videoclip nou',
      info: 'Dimensiunea maximă acceptată este de 500mb. Recomandăm comprimarea videoclipurilor înainte de încărcare, astfel încărcarea și conversia vor dura mai puțin.',
    },

    modalCandidateInfo: [
      {
        headline: 'Înregistrați răspunsul dumneavoastră video ',
        content: 'de câte ori doriți. Videoclipurile vor fi salvate imediat după înregistrare și vă puteți întoarce la interviul video folosind link-ul pe care l-ați primit pe e-mail.',
        mobileContent: 'de câte ori doriți. Adăugați videoclipul la interviu. Veți vedea cum videoclipul este încărcat și salvat în interviu. Vă puteți întoarce la interviul video folosind link-ul pe care l-ați primit pe e-mail. <br><br><strong>Dacă ecranul dumneavoastră continuă să fie negru și folosiți un dispozitiv mobil Apple, găsiți <a style="text-decoration: underline;" target="_blank" rel="noopener noreferrer" href="https://support.recright.com/en/articles/11187-recording-doesn-t-work-with-ipad-iphone">aici</a> instrucțiuni pentru rezolvarea problemei.</strong>',
      },
      {
        headline: 'După înregistrare, ',
        content: 'asigurați-vă că videoclipul merge cum trebuie și că vocea dumneavoastră se aude. Atunci când apăsați butonul „Trimitere”, răspunsul dumneavoastră va fi blocat și nu îl veți mai putea schimba.',
      },
      {
        headline: 'Atunci când ați terminat interviul, ',
        content: 'apăsați butonul „Salvare răspunsuri și încheiere interviu”. După aceea, nu vă mai puteți întoarce la interviul video. Dacă doriți să închideți această pagină dar să continuați interviul mai târziu, apăsați butonul „Continuă mai târziu”.',
      },
      {
        headline: 'Dacă aveți nevoie de ajutor ',
        content: mailto => `pentru a răspunde interviului video, apăsați butonul „ajutor” din partea dreapta-jos a paginii sau trimiteți-ne un e-mail la ${mailto}.`,
        customContent: link => `Contactați ${link}`,
      },
    ],

    navigationBar: {
      back: 'Înapoi',
      dashboard: 'Panou',
      frontpage: 'Prima pagină',
    },

    personDetails: {
      stage: 'Stage',
      namePlaceholder: 'Candidate',
      contact: 'Contact',
      links: 'Links',
      attachments: 'Attachments',
      coverLetter: 'Cover Letter',
      referrer: 'Origin',
      referrerInfo: 'The website from which the candidate came to the service.',
      noStage: 'Not in any stage yet',
      lastSeen: time => `Last seen ${time}.`,
      headerAdditionalInformation: 'Additional information',
      state: {
        invited: 'Invited',
        visited: 'Visited',
        incomplete: 'Incomplete',
        completed: 'Completed',
      },
      notVisited: 'Hasn\'t yet visited the interview.',
      scheduledInterview: 'Scheduled interview',
      scheduledInterviewInvitationSent: 'Invited to a meeting',
      scheduledInterviewInvitationExpired: 'Invitation has expired',
      scheduledInterviewInvitationEventCreated: 'Meeting:',
      scheduledInterviewReScheduleMeeting: 'Reschedule meeting',
      otherPersons: count => `Also found on ${count} other positions`,
    },

    phoneInput: {
      placeholder: example => `Număr de telefon în format ${example}`,
    },

    questionsAndResponses: {
      response: 'Response',
      noResponse: 'No response',
      resetQuestionResponse: 'Delete candidate response',
      resetQuestionResponseConfirm: questionTitle =>
        `Are you sure you want to reset the question "${questionTitle}" for the candidate and delete their response?`,
      resetQuestionResponseConfirm2: 'If you do this, candidate can retake this question.',
    },

    rating: {
      ownVote: 'Your rating',
      yourVotePlaceholder: 'You have not voted yet.',
      totalVotes: count => `Total ${count} ratings`,
      noRatings: 'No ratings yet',
      mobileModalHeader: 'Add your rating',
      yourRatingReset: 'Reset your vote',
      averageRating: 'Rating mediu',
      reset: 'resetare',
    },

    share: {
      share: 'Partajare cu',
      copy: 'Copiere link',
    },

    sort: {
      sort: 'Sortare',
    },
    supportLink: 'support@recright.com',

    typeSelect: {
      selected: 'Selectat',
      change: 'Schimbare',
    },

    video: {
      videoNotFound: 'Videoclipul este în curs de procesare sau nu a fost găsit',
      retry: 'Încearcă din nou',
    },

    videoUpload: {
      uploadPlaceholder: isMobile => (isMobile ? 'Încarcă sau înregisrează un videoclip nou' : 'Selectare fișier'),
      videoPlaceholder: 'Înregistrați-vă răspunsul',
      uploadPlaceholderCandidate: 'Încarcă un videoclip',
      submit: 'Trimiteți răspunsul',
      notAnswered: 'Nu ați răspuns încă',
      remove: 'Ștergere încercare',
      converting: 'Videoclipul este convertit. Vă rugăm așteptați...',
      uploading: 'Videoclipul se încarcă. Vă rugăm așteptați...',
      error: {
        invalid: 'Fișierul selectat este prea mare. Vă rugăm selectați alt fișier.',
        upload: 'Nu am reușit să încărcăm videoclipul, ne cerem scuze. Vă rugăm încercați din nou.',
        transcode: 'Fișierul video selectat a fost alterat sau nu este valid, vă rugăm încercați din nou.',
      },
    },

    virtualBg: {
      showMoreButtonText: 'Afișează mai mult',
      showLessButtonText: 'Afișează mai puțin',
      infoText1:
        'Păstrați fila activă în prim-plan în timpul înregistrării. Nu trebuie să folosiți nicio altă aplicație în timpul înregistrării.',
      infoText2:
        'Videoclipurile pentru fundal video funcționează cel mai bine pe cele mai recente browsere și cu un dispozitiv care este relativ nou și puternic.',
      infoText3:
        'Asigurați-vă că alte aplicații nu utilizează microfonul sau camera.',
    },

    videoResponse: {
      videoPlaceholder: 'Înregistrați-vă răspunsul',
      uploadPlaceholder: 'Încarcă un videoclip',
      submit: 'Trimiteți răspunsul',
      notAnswered: 'Nu ați răspuns încă',
      startInterview: 'Începe interviul',
    },

    webcam: {
      useVideoBgButtonText: 'Utilizați un fundal video',
      removeVideoBgButtonText: 'Îndepărtați fundalul video',
      starting: 'Pornire...',
      close: 'Închideți camera',
      remove: 'Ștergere încercare',
      record: 'Înregistrare',
      stop: 'Oprire',
      retake: 'Reluați',
      submit: 'Trimiteți răspunsul',
      converting: 'Videoclipul este convertit. Vă rugăm așteptați...',
      uploading: 'Videoclipul se încarcă. Vă rugăm așteptați...',
      downloading: 'Videoclipul se descarcă. Vă rugăm așteptați...',
      processing: 'Procesare...',
      uploadInProgress: 'Transferul video este încă în desfășurare, nu închideți browserul și nu schimbați pagina.',
      uploaded: 'Videoclipul a fost transferat.',
      error: {
        DevicesNotFoundError: 'Camera sau microfonul nu pot fi folosite. Vă rugăm verificați dacă sunt pornite.',
        NotFoundError: 'Camera sau microfonul nu pot fi folosite. Vă rugăm verificați dacă sunt pornite.',
        NotAllowedError: 'Nu ați permis accesul la cameră sau la microfon.',
        PermissionDismissedError: 'Ați închis fereastra pentru permisiune. Vă rugăm permiteți accesul la cameră și la microfon.',
        PermissionDeniedError: 'Ați refuzat accesul la cameră sau la microfon.',
        NotReadableError: 'Conexiunea la cameră sau la microfon nu este vizibilă. Este posibil să fie o problemă de hardware.',
        SecurityError: 'Camera sau microfonul nu pot fi folosite din cauza unei erori de securitate.',
        stream: 'A apărut o eroare. Vă rugăm reporniți browserul. Dacă problema persistă, vă rugăm încercați cu un alt browser.',
        download: 'Descărcarea videoclipului a eșuat. Încercați din noi?',
        upload: 'Încărcarea videoclipului a eșuat. Încercați din noi?',
        emptyBlob: 'Memoria browserului sau a dispozitivului dumneavoastră este plină și nu poate stoca înregistrarea. Vă rugăm reîncărcați pagina și dacă acest lucru nu este de ajutor, reporniți browserul. Dacă problema persistă, vă rugăm încercațu cu un alt browser.',
        alternativeRecorder: 'Puteți să încărcați fișierul și apăsând aici.',
        reconnecting: 'Conexiunea a fost întreruptă. Se încearcă reconectarea.',
      },
    },

    smsMessages: {
      invitationMessage: title =>
        `Bună ziua! Dorim să vă invităm la un interviu video ${title}! Această invitație a fost trimisă și pe adresa dvs. de e-mail. `,
    },
  },
  page: {
    interviewPreview: {
      info: 'This is a preview of the interview. Video recording is disabled and the form data is not saved.',
    },
  },
}
